
import { LANGUAGES } from '@/src/services/constants';
import { AutocompleteInput, BooleanInput, Filter, ReferenceInput, SelectInput, TextInput } from 'react-admin';

const UserFilter = (props: any) => (
    <Filter {...props}>
        {/* <TextInput label="Search" source="q" alwaysOn /> */}
        <TextInput label="Email" source="email" alwaysOn />
        <TextInput label="Nickname" source="profile.nickname" alwaysOn />
        <SelectInput label="Valid" source="profileValid" alwaysOn fullWidth choices={[
            { id: 'true', name: "Yes" },
            { id: 'false', name: "No" },
        ]} />
        <ReferenceInput label="City" source="profile.city" reference="city"

            sort={{ field: "name", order: "ASC" }} alwaysOn>
            <AutocompleteInput optionText="name"
                filterToQuery={(txt) => ({ name: txt })}
                size='small'
            />
        </ReferenceInput>
        <BooleanInput label="Deleted" source="withDeleted" alwaysOn size='medium' sx={{ padding: "4px" }} />
        <SelectInput label="Language" source='settings.uiLang' fullWidth choices={LANGUAGES} />

        <SelectInput label="Verified" source="verified" fullWidth choices={[
            { id: 'true', name: "Yes" },
            { id: 'false', name: "No" },
        ]} />

        <SelectInput label="Blocked" source="adminBlocked" fullWidth choices={[
            { id: 'true', name: "Yes" },
            { id: 'false', name: "No" },
        ]} />

        <SelectInput label="Gender" source='profile.gender' fullWidth choices={[
            { id: 'male', name: "Male" },
            { id: 'female', name: "Female" },
        ]} />
        <SelectInput label="Is Sponsor" source="profile.isSponsor" fullWidth choices={[
            { id: 'true', name: "Yes" },
            { id: 'false', name: "No" },
        ]} />
        <SelectInput label="Premium" source="premium.isActive" fullWidth choices={[
            { id: 'true', name: "Yes" },
            { id: 'false', name: "No" },
        ]} />

        {/* <ReferenceInput label="User" source="userId" reference="users" allowEmpty>
            <SelectInput optionText="name" />
        </ReferenceInput> */}
    </Filter>
)


export default UserFilter;
